import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import type { GetProps } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
const { RangePicker } = DatePicker;
type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

dayjs.extend(customParseFormat);

const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  return current && current > dayjs().endOf("day");
};
const dateFormat = "YYYY-MM-DD";
interface DatePickerAntdComponentIF {
  dateSetHandler: any;
  dateRanges: {
    startDate: any;
    endDate: any;
  };
}
const DatePickerAntdComponent: React.FC<DatePickerAntdComponentIF> = ({
  dateSetHandler,
  dateRanges,
}: DatePickerAntdComponentIF) => {
  const [dateRange, setDateRange] = useState<any>(dateRanges);
  useEffect(() => {
    if (dateRanges) {
      setDateRange(dateRanges);
    }
  }, [dateRanges]);
  const handleDateChange = (dates: any, dateStrings: any) => {
    const [startDate, endDate] = dateStrings;
    const newObj = {
      startDate: startDate,
      endDate: endDate,
    };
    dateSetHandler(newObj);
  };
  return (
    <RangePicker
      value={[
        dayjs(dateRange.startDate, dateFormat),
        dayjs(dateRange.endDate, dateFormat),
      ]}
      disabledDate={disabledDate}
      format={dateFormat}
      onChange={handleDateChange}
      size="large"
      style={{
        width: "100%",
      }}
    />
  );
};

export default DatePickerAntdComponent;
